export const PERMS = {
    READ: 'report_carrier_scoring.read',
    UPDATE: 'report_carrier_scoring.update',
}
